import { CrudForm, type SubmissionHandler } from 'components/form';
import type { Field } from 'components/types';
import { strings } from 'strings';

import { schema } from './schema';
import type { FormData, TestType } from './types';

type Props = {
  testType: TestType;
  onSubmit: SubmissionHandler<FormData>;
  fields: Field<FormData>[];
  onChange: (formData: FormData) => void;
};

export const AmpathCreateOrderForm: React.FC<Props> = ({
  fields,
  onChange,
  onSubmit,
  testType,
}) => (
  <CrudForm
    key={testType}
    fields={fields}
    initialValues={{ testType }}
    validationSchema={schema}
    buttonText={strings.ButtonTextSubmit}
    onSubmit={onSubmit}
    onChange={onChange}
    onChangeDebounceTime={0}
  />
);
